class VariantImageFilter {
  constructor() {
    if (!window.productData) {
      setTimeout(() => new VariantImageFilter(), 500);
      return;
    }

    this.productData = window.productData;
    this.mediaGallery = document.querySelector('media-gallery');
    
    if (!this.mediaGallery) {
      setTimeout(() => new VariantImageFilter(), 500);
      return;
    }

    this.analyzeImages();
    this.overrideSetActiveMedia();
    
    console.log('✓ Filtre activé - mode thumbnails uniquement');
  }

  analyzeImages() {
    const variantMediaIds = this.productData.variants
      .filter(v => v.featured_media && v.featured_media.id)
      .map(v => v.featured_media.id.toString());
    
    const allThumbs = Array.from(
      this.mediaGallery.querySelectorAll('.thumbnail-list > .swiper-slide:not(.swiper-slide-duplicate)')
    );

    this.imageMap = allThumbs.map((thumb, index) => ({
      index: index,
      mediaId: thumb.dataset.target,
      isCommon: !variantMediaIds.includes(thumb.dataset.target),
      thumb: thumb
    }));

    console.log('Images analysées:', this.imageMap.length);
    console.log('Images communes:', this.imageMap.filter(i => i.isCommon).length);
  }

  overrideSetActiveMedia() {
    const originalSetActiveMedia = this.mediaGallery.setActiveMedia.bind(this.mediaGallery);
    
    this.mediaGallery.setActiveMedia = (variant) => {
      if (!variant || !variant.featured_media) {
        this.showAllThumbnails();
      } else {
        this.filterThumbnails(variant);
      }
      
      // Appeler la méthode originale qui gère le slider principal
      originalSetActiveMedia(variant);
    };
  }

  filterThumbnails(variant) {
    const variantMediaId = variant.featured_media.id.toString();
    
    console.log('');
    console.log('=== FILTRAGE THUMBNAILS ===');
    console.log('Featured media ID:', variantMediaId);
    
    this.imageMap.forEach(img => {
      const isSelectedVariant = img.mediaId === variantMediaId;
      const shouldShow = img.isCommon || isSelectedVariant;
      
      if (shouldShow) {
        img.thumb.style.display = '';
        img.thumb.classList.remove('hidden');
        console.log(`✓ Thumbnail ${img.index} visible`);
      } else {
        img.thumb.style.display = 'none';
        img.thumb.classList.add('hidden');
        console.log(`✗ Thumbnail ${img.index} cachée`);
      }
    });
    
    // Mettre à jour uniquement le slider des thumbnails
    setTimeout(() => {
      if (this.mediaGallery.thumbsInstance?.slider) {
        this.mediaGallery.thumbsInstance.slider.update();
        console.log('Thumbnails slider mis à jour');
      }
    }, 50);
  }

  showAllThumbnails() {
    console.log('=== AFFICHAGE TOUTES THUMBNAILS ===');
    
    this.imageMap.forEach(img => {
      img.thumb.style.display = '';
      img.thumb.classList.remove('hidden');
    });
    
    setTimeout(() => {
      if (this.mediaGallery.thumbsInstance?.slider) {
        this.mediaGallery.thumbsInstance.slider.update();
      }
    }, 50);
  }
}

setTimeout(() => new VariantImageFilter(), 1500);